// client/src/components/HomeAffiliates.js
// (tu avais "HomesAffiliates.js" dans le commentaire, mais ton export est HomeAffiliates)

import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import HomeFooter from "./HomeFooter";
import HomeHeader from "./HomeHeader";
import { HomeStyles, StepLine, FeatureCard } from "./HomeUI";

export default function HomeAffiliates() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const banner =
    "https://firebasestorage.googleapis.com/v0/b/ecobill-pay.firebasestorage.app/o/Administratif%2Fbanniere_home_affiliates.png?alt=media&token=bd8bac01-3750-42f7-9848-698c1a31a2ae";

  const features = useMemo(
    () => [
      {
        emoji: "🤝",
        title: "Partenariat",
        reverse: false,
        content: (
          <ul className="lp-checks">
            <StepLine>Rejoignez le Programme Ecobill Affiliates</StepLine>
            <StepLine>Accédez à un dashboard clé en main</StepLine>
          </ul>
        ),
      },
      {
        emoji: "💰",
        title: "Commissions",
        reverse: true,
        content: (
          <ul className="lp-checks">
            <StepLine>Cumulez des commissions sur les abonnements apportés</StepLine>
            <StepLine>Statistiques automatisées dans votre dashboard</StepLine>
          </ul>
        ),
      },
      {
        emoji: "📊",
        title: "Dashboard",
        reverse: false,
        content: (
          <ul className="lp-checks">
            <StepLine>Suivez vos prospects et vos ventes en temps réel</StepLine>
            <StepLine>Consultez vos statistiques et commissions</StepLine>
            <StepLine>Analysez vos performances par période</StepLine>
          </ul>
        ),
      },
      {
        emoji: "🎯",
        title: "Support dédié",
        reverse: true,
        content: (
          <>
            <p className="lp-text" style={{ marginBottom: 14 }}>
              Vous êtes accompagnés pour performer, avec des ressources et un support réactif.
            </p>
            <ul className="lp-checks">
              <StepLine>Accompagnement personnalisé</StepLine>
              <StepLine>Ressources exclusives</StepLine>
            </ul>
          </>
        ),
      },
    ],
    []
  );

  return (
    <div className={`lp-page${isMobile ? " is-mobile" : ""}`}>
      <HomeStyles />
      <HomeHeader />

      <header className="lp-hero">
        <div className="lp-shell">
          <div className="lp-hero__grid">
            <div>
              <span className="lp-eyebrow">
                <span className="lp-eyebrow__dot" aria-hidden="true" />
                Ecobill — Affiliates
              </span>

              <h1 className="lp-h1">Développez vos revenus avec Ecobill</h1>

              <p className="lp-lead">
                Un programme simple : prospects, suivi, stats et commissions dans un dashboard.
              </p>

              <div className="lp-actions">
                <Link to="/affiliatessignup" className="lp-btn lp-btn--primary">
                  Devenir Affiliate <span className="lp-btn__arrow" aria-hidden="true">→</span>
                </Link>
              </div>
            </div>

            <div className="lp-media">
              <img src={banner} alt="Bannière affiliates" />
            </div>
          </div>

          {/* JOIN (léger, sous l'image, sans overlay) */}
          <div className="lp-band" style={{ marginTop: 40 }}>
            <div>
              <div className="lp-band__title">Rejoindre l’aventure Affiliate</div>
              <div className="lp-band__text">Accès dashboard • suivi • commissions</div>
            </div>
          </div>
        </div>
      </header>

      <main className="lp-main">
        <div className="lp-shell">
          <section className="lp-section">
            <div className="lp-grid">
              {features.map((f, i) => (
                <FeatureCard key={i} emoji={f.emoji} title={f.title}>
                  {f.content}
                </FeatureCard>
              ))}
            </div>
          </section>
        </div>
      </main>

      <HomeFooter />
    </div>
  );
}
